// Formatação no estilo X (twitter), sem dependências.
// Portado de adverse-start/src/lib/xFormat.js (mesmos posts, mesmas regras).

const MONTHS = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];

// "12min", "5h", "16 de mar", "16 de mar de 2025", igual ao X
export function formatRelative(iso) {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';

  const now = new Date();
  const diffSec = Math.floor((now - date) / 1000);

  if (diffSec < 60) return `${Math.max(diffSec, 1)}s`;
  if (diffSec < 3600) return `${Math.floor(diffSec / 60)}min`;
  if (diffSec < 86400) return `${Math.floor(diffSec / 3600)}h`;

  const label = `${date.getDate()} de ${MONTHS[date.getMonth()]}`;
  return date.getFullYear() === now.getFullYear() ? label : `${label} de ${date.getFullYear()}`;
}

// A hashtag exige ao menos uma letra: "#1 Produto" e "#002" nos posts são
// numeração de tópico, não hashtag (o X também não linka esses).
const TOKEN_RE =
  /(https?:\/\/[^\s<>"']+)|(@[A-Za-z0-9_]{1,15})|(#(?=[\p{L}\p{N}_]*[\p{L}_])[\p{L}\p{N}_]+)/gu;

// Encurta a URL para exibição, como o X faz: "x.com/joaobrocatto/s…"
export function displayUrl(url) {
  try {
    const parsed = new URL(url);
    const host = parsed.hostname.replace(/^www\./, '');
    const rest = `${parsed.pathname}${parsed.search}`.replace(/\/$/, '');
    const full = `${host}${rest}`;
    return full.length > 30 ? `${full.slice(0, 30)}…` : full;
  } catch {
    return url;
  }
}

// Quebra o texto em tokens renderizáveis (texto, url, menção, hashtag)
export function tokenize(text) {
  const tokens = [];
  let cursor = 0;

  for (const match of String(text).matchAll(TOKEN_RE)) {
    const [raw, url, mention, hashtag] = match;
    if (match.index > cursor) {
      tokens.push({ type: 'text', value: text.slice(cursor, match.index) });
    }
    if (url) tokens.push({ type: 'url', value: raw });
    else if (mention) tokens.push({ type: 'mention', value: raw });
    else if (hashtag) tokens.push({ type: 'hashtag', value: raw });
    cursor = match.index + raw.length;
  }

  if (cursor < text.length) tokens.push({ type: 'text', value: text.slice(cursor) });
  return tokens;
}

// Corta post longo como o X faz no feed ("Mostrar mais"). Corta num espaço ou
// quebra de linha, então nunca parte uma URL no meio.
export function truncatePost(text, limit = 280) {
  if (text.length <= limit) return { text, truncated: false };
  let cut = Math.max(text.lastIndexOf(' ', limit), text.lastIndexOf('\n', limit));
  if (cut < limit * 0.6) cut = limit;
  return { text: text.slice(0, cut).trimEnd(), truncated: true };
}

// Aspecto de uma imagem, limitado à faixa que o X usa (evita imagem gigante)
export function clampAspect(width, height, min = 0.75, max = 1.78) {
  if (!width || !height) return 16 / 9;
  return Math.min(Math.max(width / height, min), max);
}
